export const FETCH_SAME_DAY_BAGS = {
    REQUEST: 'BAG.LIST_SAME_DAY_BAGS.FETCH_SAME_DAY_BAGS.REQUEST',
    SUCCESS: 'BAG.LIST_SAME_DAY_BAGS.FETCH_SAME_DAY_BAGS.SUCCESS',
    FAILED: 'BAG.LIST_SAME_DAY_BAGS.FETCH_SAME_DAY_BAGS.FAILED',
};

export const CLEAR_STATE = 'BAG.LIST_SAME_DAY_BAGS.CLEAR_STATE';
